/* unplugin-vue-components disabled */import script from "./VideoTags.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoTags.vue?vue&type=script&setup=true&lang=js"

import "./VideoTags.vue?vue&type=style&index=0&id=c0d58ae8&lang=scss"

const __exports__ = script;

export default __exports__